// The Client Care Letter chip on the Golden Rule strip (MatterIntakeDetail).

export function cclStripStatus({
  signingStatus, submission, feeEarnerSigApplied, docxReviewed, pipelineStatus,
} = {}) {
  const sub = submission || {};
  // BM-H474 (9 Sep 2026): "signed" is the value GET /api/submissions/{id} now
  // reports when every recorded signing request has come back signed. Without
  // it the strip read a signed CCL as still in progress.
  const signedViaRequests = signingStatus === "completed" || signingStatus === "both_signed" || signingStatus === "fully_signed" || signingStatus === "signed";
  // BM-H3512 (3 Oct 2026): a signature or acceptance recorded on the
  // onboarding record itself (ccl_signed_at, or status ccl_signed). The
  // off-system confirm route (POST /api/ccl/off-system/{ref}/accepted) writes
  // only that record, never signing_requests, so reading signing_status alone
  // left the chip on "Sent manually" after the client had confirmed. This is
  // the same BM-H503 predicate the board uses.
  const signedOnRecord = pipelineStatus?.ccl_signature_recorded === true;
  const cclSigned = signedViaRequests || signedOnRecord;
  const acceptedOffSystem = !signedViaRequests && signedOnRecord
    && pipelineStatus?.ccl_signed_source === "off_system";
  const cclSent = signingStatus === "pending_client" || sub.status === "sent" || sub.status === "care_pack_prepared";
  // BM-H3443: a letter sent by hand outside CaseMinder is sent, not signed.
  const cclSentManually = Boolean(pipelineStatus?.ccl_sent_manually);
  const status = cclSigned ? "complete" : (cclSent || feeEarnerSigApplied || cclSentManually) ? "in_progress" : (docxReviewed || sub.ccl_html) ? "in_progress" : "pending";
  const label = acceptedOffSystem
    ? "Client accepted"
    : cclSigned
    ? "Fully signed"
    : cclSentManually ? "Sent manually"
    : feeEarnerSigApplied && cclSent ? "Sent to client"
    : feeEarnerSigApplied ? "Fee earner signed"
    : docxReviewed ? "Reviewed"
    : sub.ccl_html ? "Created"
    : "Not started";
  return { signed: cclSigned, status, label };
}
